import React from 'react'
import { PrismicLink, PrismicRichText } from '@prismicio/react'
import { GatsbyImage, getImage } from 'gatsby-plugin-image'

const Hero = ({ slice }) => {
  return (
    <section className='component-hero relative'>
      {slice.primary.image && (
        <div className='absolute inset-0 col-span-full row-span-full'>
          <GatsbyImage className='h-full w-full' image={getImage(slice.primary.image)} alt={slice.primary.image.alt || ''} />
          <div className='absolute inset-0 bg-stone-950 bg-opacity-50' />
        </div>
      )}
      <div className='hero col-span-full row-span-full flex w-full flex-col items-center justify-center gap-6 p-4 md:px-8 lg:px-12 py-32 lg:pt-44 text-center md:mx-auto md:max-w-screen-2xl md:items-start md:text-left'>
        <div className='prose prose-lg prose-invert drop-shadow font-semibold lg:prose-xl relative md:max-w-screen-md'>
          <PrismicRichText field={slice.primary.title.richText} />
          <PrismicRichText field={slice.primary.text.richText} />
        </div>
        <PrismicLink className='button' field={slice.primary.button_link}>
          {slice.primary.button_text}
        </PrismicLink>
      </div>
    </section>
  )
}

export default Hero
